import React, { useState } from 'react'
import { Collapse, Space, Radio, Checkbox, Form, Input, Row, Col, Select, Button, Card, message, Steps, DatePicker, } from "antd";
import Footer from '../../../components/common/Footer';
import PageHeading from '../../../components/common/PageHeading'
import RightBar from '../../../components/common/RightBar'
import RightBarMethod from '../../../components/common/RightBar/RightBarMethod';

function RentIncrease() {

    const RentIncreaseRightBar = [
        RightBarMethod(
            " REPORTS",
            "t4",
            <i className="fa-solid fa-chart-column"></i>,
            [
              RightBarMethod("Lease Expiration Detail By Month", "17", "", "", "/"),
            ]
          ),
    ];

    const SearchContent = () => {
        return (
            <>
                <h2>Step 1: Search for eligible residents.</h2>
                <br />
                <Form.Item
                    label="Properties"
                    wrapperCol={{ span: 12 }}>

                    <Select showSearch />
                </Form.Item>

                <Form.Item
                    label="Units"
                    wrapperCol={{ span: 12 }}>

                    <Select showSearch />
                </Form.Item>

                <Form.Item
                    label="Keyword"
                    wrapperCol={{ span: 12 }}>

                    <Select showSearch />
                </Form.Item>

                <Form.Item
                    label="Eligible for increase before"
                    wrapperCol={{ span: 6 }}>

                    <DatePicker style={{ width: '100%' }} />
                </Form.Item>

                <Form.Item
                    label="Include residents Not Eligible for renewal"
                    wrapperCol={{ span: 6 }}>
                    <Checkbox />
                </Form.Item>

                <Form.Item
                    label=" "
                    wrapperCol={{ span: 6 }}>
                    <Button type="primary" onClick={() => next()}>
                        Search
                    </Button>
                </Form.Item>

            </>
        )
    }

    const SetIncreaseContent = () => {
        return (
            <>
                <h2>Step 2: Set Increases</h2>
                <br />
                <p>Here are the residents that are eligible for an increase. Click the Preview Increases button to continue, or <Button type='link' style={{ padding: 0 }}>search again</Button>.</p>

                <Row>
                    <Col span={12} style={{ paddingRight: 8 }}>
                        <Card title="Increase by Percentage" style={{ width: '100%' }}>

                            <Input suffix="%" />

                            <Button type='primary' style={{ marginTop: 16 }}>Update by Percentage</Button>

                        </Card>
                    </Col>

                    <Col span={12} style={{ paddingLeft: 8 }}>
                        <Card title="Increase by Flat Amount" style={{ width: '100%' }}>

                            <Input suffix="$" />

                            <Button type='primary' style={{ marginTop: 16 }}>Update by Flat Amount</Button>

                        </Card>
                    </Col>
                </Row>

                <Row style={{ marginTop: 12 }}>
                    <Col className="tableHead" span={1} style={{ padding: 0, display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <Checkbox />
                    </Col>
                    <Col className="tableHead" span={11}>
                        <p>Resident</p>
                    </Col>
                    <Col className="tableHead" span={4}>
                        <p>Increase Date</p>
                    </Col>
                    <Col className="tableHead" span={4}>
                        <p>Current Charge</p>
                    </Col>
                    <Col className="tableHead" span={4}>
                        <p>New Charge</p>
                    </Col>
                </Row>

                <SetIncreaseContentItem />

                <br />

                <Button type="primary" onClick={() => next()}>Preview Increase</Button>
                <Button style={{ margin: '0 8px' }} onClick={() => prev()}>Back</Button>

            </>
        )
    }

    const SetIncreaseContentItem = () => {
        return (
            <Row style={{ backgroundColor: "#fff" }}>
                <Col span={1} style={{ padding: 0, display: "flex", justifyContent: "center" }}>
                    <Checkbox style={{ marginTop: 8 }} />
                </Col>
                <Col span={11} style={{ padding: 8 }}>
                    <Space><p style={{ fontWeight: 600 }}>Name</p><p>Sunken, William</p></Space><br />
                    <Space><p style={{ fontWeight: 600 }}>Property</p><p>1500 NE 43rd St Oklahoma City, OK 73111</p></Space><br />
                    <Space><p style={{ fontWeight: 600 }}>Unit</p><p></p></Space><br />
                    <Space><p style={{ fontWeight: 600 }}>Last Increase</p><p>02/01/2024</p></Space><br />
                    <Space><p style={{ fontWeight: 600 }}>Eligible for Increase</p><p>02/01/2025</p></Space><br />
                    <Space><p style={{ fontWeight: 600 }}>Eligible for Renewal</p><p>Yes</p></Space><br />
                </Col>
                <Col span={4} style={{ padding: 8 }}>
                    <DatePicker style={{ width: '100%' }} />
                </Col>
                <Col span={4} style={{ padding: 8, display: "flex", justifyContent: "right" }}>
                    <p>775.00</p>
                </Col>
                <Col span={4} style={{ padding: 8 }}>
                    <Input prefix="$" />
                </Col>
            </Row>
        )
    }

    const ScheduleIncreaseContent = () => {
        return (
            <>
                <h2>Step 3: Schedule Increases</h2>
                <br />

                <Row style={{ marginTop: 12 }}>
                    <Col className="tableHead" span={12}>
                        <p>Resident</p>
                    </Col>
                    <Col className="tableHead" span={4}>
                        <p>Increase Date</p>
                    </Col>
                    <Col className="tableHead" span={4}>
                        <p>Current Charge</p>
                    </Col>
                    <Col className="tableHead" span={4}>
                        <p>New Charge</p>
                    </Col>
                </Row>

                <ScheduleIncreaseContentItem />

                <br />

                <Button type="primary" onClick={() => next()}>Schedule Increase</Button>
                <Button style={{ margin: '0 8px' }} onClick={() => prev()}>Back</Button>


            </>
        )
    }

    const ScheduleIncreaseContentItem = () => {
        return (
            <Row style={{ backgroundColor: "#fff" }}>

                <Col span={12} style={{ padding: 8 }}>
                    <Space><p style={{ fontWeight: 600 }}>Name</p><p>Sunken, William</p></Space><br />
                    <Space><p style={{ fontWeight: 600 }}>Property</p><p>1500 NE 43rd St Oklahoma City, OK 73111</p></Space><br />
                    <Space><p style={{ fontWeight: 600 }}>Unit</p><p></p></Space><br />
                    <Space><p style={{ fontWeight: 600 }}>Last Increase</p><p>02/01/2024</p></Space><br />
                    <Space><p style={{ fontWeight: 600 }}>Eligible for Increase</p><p>02/01/2025</p></Space><br />
                    <Space><p style={{ fontWeight: 600 }}>Eligible for Renewal</p><p>Yes</p></Space><br />
                </Col>
                <Col span={4} style={{ padding: 8 }}>
                    <p>02/01/2024</p>
                </Col>
                <Col span={4} style={{ padding: 8, display: "flex", justifyContent: "right" }}>
                    <p>775.00</p>
                </Col>
                <Col span={4} style={{ padding: 8, display: "flex", justifyContent: "right" }}>
                    <p>0.00</p>
                </Col>
            </Row>
        )
    }

    const DownloadLettersContent = () => {
        return (
            <>
                <h2>Step 4: Download letters and envelopes</h2>
                <br />

                <Row style={{ marginTop: 12 }}>
                    <Col className="tableHead" span={4} style={{ paddingLeft: 8, display: "flex", alignItems: "center" }}>
                        <Checkbox>Letters</Checkbox>
                    </Col>
                    <Col className="tableHead" span={4} style={{ paddingLeft: 8, display: "flex", alignItems: "center" }}>
                        <Checkbox>Emails</Checkbox>
                    </Col>
                    <Col className="tableHead" span={6}>
                        <p>Name</p>
                    </Col>
                    <Col className="tableHead" span={5}>
                        <p>Start Date</p>
                    </Col>
                    <Col className="tableHead" span={5}>
                        <p>New Rent Amount</p>
                    </Col>
                </Row>

                <DownloadLettersContentItem />

                <br />

                <Button type="primary" onClick={() => {}}>Download Letters</Button>
                <Button style={{ margin: '0 8px' }} type="primary" onClick={() => {}}>Download Emails</Button>
                <Button type="primary" onClick={() => {}}>Download Letters</Button>
                <Button style={{ margin: '0 8px' }} onClick={() => {}}>Done</Button>

            </>
        )
    }

    const DownloadLettersContentItem = () => {
        return (
            <>
                <Row style={{ paddingTop:6, paddingBottom:6, backgroundColor:"#fff" }}>
                    <Col span={4} style={{ paddingLeft: 8, display: "flex", alignItems: "center" }}>
                        <Checkbox />
                    </Col>
                    <Col span={4} style={{ paddingLeft: 8, display: "flex", alignItems: "center" }}>
                        <Checkbox />
                    </Col>
                    <Col span={6}>
                        <p>William Sunken</p>
                    </Col>
                    <Col span={5}>
                        <p>02/01/2025</p>
                    </Col>
                    <Col span={5}>
                        <p>0.00</p>
                    </Col>
                </Row>

            </>
        )
    }

    const steps = [
        {
            title: 'Search',
            content: <SearchContent />,
        },
        {
            title: 'Set Increase',
            content: <SetIncreaseContent />,
        },
        {
            title: 'Schedule Increase',
            content: <ScheduleIncreaseContent />,
        }, {
            title: 'Download Letters',
            content: <DownloadLettersContent />,
        },
    ];

    const [current, setCurrent] = useState(0);
    const next = () => {
        setCurrent(current + 1);
    };
    const prev = () => {
        setCurrent(current - 1);
    };
    const items = steps.map((item) => ({
        key: item.title,
        title: item.title,
    }));
    const contentStyle = {
        marginTop: 16,
        padding: 16,
    };

    return (
        <>
            <div className="page-container">
                <div className="main-container">
                    <PageHeading heading="Rent Increase" />

                    <Form
                        name="basic"
                        labelCol={{ span: 6 }}
                        initialValues={{ remember: true }}
                        autoComplete="off"
                        className="form-container"
                        colon={false}
                    >
                        <Row>
                            <Col span={24}>

                                <Steps current={current} items={items} labelPlacement="vertical" />

                                <div style={contentStyle}>{steps[current].content}</div>

                            </Col>
                        </Row>
                    </Form>

                    <Footer />

                </div>
            </div>

            <div className="RightSidebar">
                <RightBar RightBarData={RentIncreaseRightBar} />
            </div>
        </>
    )
}

export default RentIncrease